<template>
  <section class="topics">
    <div class="tree">
      <p class="h2">
        Topics
      </p>
      <div
        v-for="(category, idx) in tree"
        :key="idx"
        class="category"
        :class="{ opened: category.opened }"
      >
        <p :class="{ active: category.slug === $route.params.id }" @click="$store.commit('support/toggleArticles', idx)">
          <span>{{ category.category }}</span>
          <ArrowDown v-if="!category.opened" />
          <ArrowUp v-else />
        </p>
        <ul>
          <li v-for="(article, i) in category.articles" :key="i" class="article">
            <nuxt-link :to="`/support/${article.slug}/`" :class="{ active: article.slug === $route.params.id }">
              {{ article.title }}
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <p class="h3">
        Can’t find what you’re looking for?
      </p>
      <small>Contact support and we’ll answer shortly.</small>
      <nuxt-link to="/contact-us/" class="btn-primary-transparent">
        Contact support
      </nuxt-link>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import ArrowUp from '../../assets/svg/icon-arrow-up.svg?vue-component';
import ArrowDown from '../../assets/svg/icon-arrow-down.svg?vue-component';

export default {
  components: { ArrowUp, ArrowDown },
  computed: mapState('support', ['tree']),
  mounted() {
    this.$store.commit('support/setArticlesTree', this.$store.state.support.tree.map((p) => ({ ...p, opened: false })));
    const topicIdx = this.tree.findIndex((c) => c.slug === this.$route.params.id || (c.articles.filter((a) => a.slug === this.$route.params.id)).length);

    if (topicIdx >= 0) {
      this.$store.commit('support/toggleArticles', topicIdx);
    }
  },
};
</script>

<style lang="scss" scoped>

.topics {
  .tree {
    .h2 {
      font-size: 21px;
      margin-bottom: var(--spacing-16);
      margin-top: 0;
    }

    .category {
      > p {
        font-size: var(--base-font);
        font-weight: 500;
        color: var(--main-dark-shade-0);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0;
        padding: var(--spacing-14) 0;
        width: 100%;

        svg {
          width: 16px;
          height: 8px;
        }
      }

      ul {
        display: none;
        list-style: none;
        padding-left: var(--spacing-sm);

        li {
          margin-bottom: var(--spacing-24);
          font-size: 12px;
          line-height: 110%;

          &:last-child {
            margin-bottom: 12px;
          }

          a {
            color: var(--main-dark-shade-0);
            line-height: 19px;
            font-size: 12px;
            display: inline-block;

            &:hover {
              text-decoration: none;
              color: var(--accent-shade-2);
              font-weight: 600;
            }
          }
        }
      }

      &.opened {
        p svg path[stroke] {
          stroke: var(--accent-shade-2);
        }

        ul {
          display: block;
        }
      }

      .active {
        color: var(--accent-shade-2);
        font-weight: 600;
      }
    }
  }

  .contact {
    border: 1px solid var(--main-light-shade-2);
    border-radius: 3px;
    background-color: var(--accent-light-1);
    padding: var(--spacing-22) var(--spacing-14);
    margin-top: var(--spacing-32);

    .h3 {
      font-size: 14px;
      font-weight: normal;
      line-height: 130%;
      margin: 0;
    }

    small {
      font-size: 12px;
      margin-bottom: var(--spacing-mdsm);
      margin-top: 3px;
      display: block;
      line-height: 110%;
    }

    .btn-primary-transparent {
      color: var(--accent);
      padding: 0.5em 1em;
      line-height: 24px;
      font-weight: 600;

      &:hover,
      &:active {
        color: var(--main-light);
        background-color: var(--accent);
        border-color: var(--accent);
      }
    }

    .btn-outline-primary {
      text-align: center;
    }
  }
}

@media (max-width: 768px) {
  .topics {
    max-width: 100%;
    flex: 0 0 100%;
    order: 1;

    .tree {
      display: none;
    }

    .contact {
      padding: var(--spacing-22) var(--spacing-28);

      .h3 {
        font-size: 18px;
      }

      small {
        font-size: 14px;
        margin-bottom: var(--spacing-12) !important;
      }

      .btn-outline-primary {
        padding-top: 0.8em;
        padding-bottom: 0.8em;
      }
    }
  }
}

.fa .topics .contact .btn-primary-transparent {
  font-size: 16px;
}

@include bp($bp-laptop) {
  .fa .topics .contact .btn-primary-transparent {
    width: 156px;
    padding: 7px 0;
  }
}

</style>
